module.exports = __webpack_public_path__ + "static/media/add_circle.a43d0b4a.svg";